module.exports = __webpack_public_path__ + "img/Box-decline.ec288f72.png";